import { render, staticRenderFns } from "./ServiceEdit.vue?vue&type=template&id=68202c5e&"
import script from "./ServiceEdit.vue?vue&type=script&lang=js&"
export * from "./ServiceEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports